const isDebugEnabled = () => process.env.GATSBY_KLAVIYO_CART_TRACKING_DEBUG === 'true'
const isDev = () => process.env.NODE_ENV === 'development'

export function logKlaviyoCartDebug(label, payload) {
  if (!isDebugEnabled()) return
  console.log(`[Klaviyo Cart] ${label}`, payload)
}

export function logKlaviyoCartSyncMarker(source) {
  if (!isDev()) return

  console.log(`[Klaviyo Cart Sync] ${source}`)
}
